import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with the way mathematics is ruling the world, I love Vector calculus the most.
              <br />
              <br />I am fluent in technology stacks like
              <i>
                <b className="purple"> C++, Matlab, Python, R and Verilog. </b>
              </i>
              <br />
              <br />
              My field of Interest's includes &nbsp;
              <i>
                <b className="purple">Core Mathematics, Digital Electronics, Deep learning and Reinforcement learning </b>
              </i>
              and their applications in areas related to{" "}
              <i>
                <b className="purple">
                  Controls, Pattern Recognition, Robotics and Communication Systems.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I am trying to apply my knowledge of mathematics
              in
              <i>
                <b className="purple"> learning and exploring Data Science</b>
              </i>
              &nbsp; using knowledge of 
              <i>
                <b className="purple"> Probability and Statistics with R/python.</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
